import React, {Component} from 'react';
import {Form} from 'antd';
import {connect} from 'react-redux';
import {queryIncCustomProject} from '@api/incubator/custom';
import DescriptionList from '@comm/DescriptionList';

const { Description } = DescriptionList;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectList: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getProjectList();
  }

  componentWillReceiveProps(nextProps) {}

  getProjectList = () => {
    queryIncCustomProject({
      customUuid: this.props.params.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          projectList: res.data,
        });
      }
    });
  };

  render() {
    const { projectList } = this.state;
    return (
      <Form onSubmit={this.submit}>
        {projectList.map((item, index) => (
          <div key={item.id}>
            <DescriptionList size="large" col={1} title={`项目${index + 1}`}>
              <Description term="项目名称">{item.projectName}</Description>
              <Description term="项目介绍">{item.remark}</Description>
            </DescriptionList>
          </div>
        ))}
      </Form>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(
  Form.create({ wrappedComponentRef: true })(BaseForm),
);



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/CardProject.js